import React from 'react';
import { makeStyles, Button, Checkbox } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { IBulkActions } from './types';

const useStyles = makeStyles((theme) => ({
    bulkOperations: {
        position: 'relative',
    },
    bulkActions: {
        paddingLeft: 4,
        paddingRight: 4,
        marginBottom: '1em',
        width: '100%',
        zIndex: 2,
        backgroundColor: theme.palette.background.paper,
    },
    bulkAction: {
        marginLeft: theme.spacing(2),
        color: '#FFFFFF',
        backgroundColor: theme.palette.error.main,
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
    },
}));

export const BulkActions = ({
    handleOpen,
    handleSelectAll,
    selectedSome,
    selectedAll,
    selectedItems,
    ...props
}: IBulkActions) => {
    const classes = useStyles();

    const { t } = useTranslation();

    return (
        <div className={classes.bulkOperations} {...props}>
            <div className={classes.bulkActions}>
                <Checkbox
                    checked={selectedAll}
                    indeterminate={selectedSome}
                    onChange={handleSelectAll}
                />
                <Button
                    variant="outlined"
                    className={classes.bulkAction}
                    onClick={() => handleOpen()}
                >
                    {t('Buttons.Delete')}
                </Button>
            </div>
        </div>
    );
};
